import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { addIcons } from 'ionicons';
import {
  alertCircleOutline,
  locationOutline,
  personOutline,
  logoGoogle,
  locateOutline,
  copyOutline,
  closeCircleOutline,
  informationCircleOutline,
  checkmarkCircleOutline
} from 'ionicons/icons';

// Register icons with kebab-case keys (only icons used in viewer app)
addIcons({
  'alert-circle-outline': alertCircleOutline,
  'location-outline': locationOutline,
  'person-outline': personOutline,
  'logo-google': logoGoogle,
  'locate-outline': locateOutline,
  'copy-outline': copyOutline,
  'close-circle-outline': closeCircleOutline, // from shared dismissable-alert
  'information-circle-outline': informationCircleOutline, // from shared dismissable-alert + getUpdateMessageIcon
  'checkmark-circle-outline': checkmarkCircleOutline // from getUpdateMessageIcon
});

// Prevent debug tokens in deployed environments (allow on localhost)
const isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const allowDebugToken = environment.useAppCheckDebugToken || isLocalhost;

if (!allowDebugToken) {
  Object.defineProperty(window, 'FIREBASE_APPCHECK_DEBUG_TOKEN', {
    get: () => null,
    set: (val) => console.debug('[App Check] Prevented setting debug token:', val),
    configurable: true,
  });

  localStorage.removeItem('firebase:debugAppCheckToken');
  console.debug('[App Check] Explicitly neutralized AppCheck debug token in deployed environment.');
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

